enum JobStatus {
	Open = 10,
	Closed = 91,
}

export default JobStatus;